import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Typography, Button } from '@mui/material'
import Layout from "../Layout"
import './NotFound.scss'

const PageNotFound = () => {
  return (
    <Layout>
      <Box className="page-404">
        <Typography variant="h1">
          404
        </Typography>
        <Typography variant="h6">
          Page Not Found
        </Typography>
        <Typography sx={{ pb: 2 }}>
          The page you're looking fo does not seem to exist
        </Typography>
        <Link to="/" className="no_underline text-white">
          <Button className="btn-info">
            Go to Home
          </Button>
        </Link>
      </Box>
    </Layout>
  )
}

export default PageNotFound;